export default {
    address: [],
    mainAddress: null
}
  